<template>
  <div class="product-solutions-page">
    <!-- 产品概览Banner -->
    <div class="product-banner" data-aos="fade">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1>善信医养智慧养老产品矩阵</h1>
        <p class="banner-subtitle">
          全方位数字化解决方案，赋能养老服务体系升级
        </p>
        <div class="product-scroll-hint">
          <span>探索我们的产品</span>
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
    </div>

    <!-- 产品解决方案 -->
    <div class="solutions-section">
      <div class="section-header" data-aos="fade-up">
        <h2>智慧养老产品解决方案</h2>
        <p class="section-subtitle">覆盖机构、社区、居家全场景需求</p>
      </div>

      <div class="product-showcase">
        <div
          v-for="(product, index) in products"
          :key="index"
          class="product-card"
          :data-aos="'fade-up'"
          :data-aos-delay="index * 150"
        >
          <div
            class="card-inner"
            :class="{ 'is-flipped': product.isFlipped }"
            @click="product.isFlipped = !product.isFlipped"
          >
            <div class="card-front">
              <div
                class="product-icon"
                :style="{ backgroundColor: product.color }"
              >
                <i :class="product.icon"></i>
              </div>
              <h3>{{ product.name }}</h3>
              <p class="product-brief">{{ product.brief }}</p>
              <div class="flip-hint">
                <i class="el-icon-refresh"></i> 点击了解更多
              </div>
            </div>
            <div class="card-back">
              <h4>核心功能</h4>
              <ul class="feature-list">
                <li v-for="(feature, fIndex) in product.features" :key="fIndex">
                  <i class="el-icon-check"></i> {{ feature }}
                </li>
              </ul>
              <!-- <div class="product-cta">
                <el-button type="primary" plain size="small"
                  >查看详情</el-button
                >
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品协同工作流程 -->
    <div class="workflow-section">
      <div class="section-header" data-aos="fade-up">
        <h2>产品协同工作流程</h2>
        <p class="section-subtitle">无缝连接，构建完整智慧养老生态</p>
      </div>

      <div class="workflow-steps" data-aos="fade-up" data-aos-delay="200">
        <div
          v-for="(step, index) in workflow"
          :key="index"
          class="workflow-step"
          :style="{ '--step-color': step.color }"
        >
          <div class="step-number">{{ index + 1 }}</div>
          <div class="step-content">
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
          <div class="step-product">
            <div class="product-badge" :style="{ backgroundColor: step.color }">
              <i :class="step.icon"></i>
              <span>{{ step.product }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术优势 -->
    <div class="tech-advantages">
      <div class="section-header" data-aos="fade-up">
        <h2>技术优势与特点</h2>
        <p class="section-subtitle">专业自研团队，打造稳定可靠的产品体系</p>
      </div>

      <div class="advantage-cards">
        <div
          v-for="(advantage, index) in techAdvantages"
          :key="index"
          class="advantage-card"
          :data-aos="'fade-up'"
          :data-aos-delay="index * 100"
        >
          <div class="advantage-icon">
            <i :class="advantage.icon"></i>
          </div>
          <h3>{{ advantage.title }}</h3>
          <p>{{ advantage.description }}</p>
        </div>
      </div>
    </div>

    <!-- 产品案例展示 -->
    <!-- <div class="case-showcase">
      <div class="section-header" data-aos="fade-up">
        <h2>成功案例展示</h2>
        <p class="section-subtitle">已服务全国500+养老机构</p>
      </div>

      <div class="case-carousel" data-aos="fade-up" data-aos-delay="200">
        <div class="case-track">
          <div
            v-for="(caseItem, index) in cases"
            :key="index"
            class="case-card"
          >
            <div class="case-image">
              <img :src="caseItem.image" alt="" />
            </div>
            <div class="case-content">
              <h3>{{ caseItem.title }}</h3>
              <p class="case-desc">{{ caseItem.description }}</p>
              <div class="case-stats">
                <div
                  class="stat-item"
                  v-for="(stat, sIndex) in caseItem.stats"
                  :key="sIndex"
                >
                  <div class="stat-value">{{ stat.value }}</div>
                  <div class="stat-label">{{ stat.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 底部CTA -->
    <div class="product-cta" data-aos="fade-up">
      <div class="cta-content">
        <h2>立即体验善信医养智慧养老产品</h2>
        <p>专业顾问将为您提供1对1产品演示与咨询服务</p>
        <el-button type="primary" round class="cta-button" @click="_goContact"
          >免费获取产品方案</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "aos/dist/aos.css";
import AOS from "aos";

export default {
  name: "ProductSolutionsPage",
  data() {
    return {
      products: [
        {
          name: "智能通话中心",
          brief: "高效稳定的语音通信解决方案",
          icon: "el-icon-phone-outline",
          color: "#FF6B6B",
          isFlipped: false,
          features: [
            "高清语音通话质量",
            "智能来电分配",
            "通话录音与质检",
            "实时监控大屏",
            "数据统计分析",
          ],
        },
        {
          name: "养老App",
          brief: "长者与家属的便捷服务平台",
          icon: "el-icon-mobile-phone",
          color: "#4ECDC4",
          isFlipped: false,
          features: [
            "健康数据监测",
            "紧急呼叫功能",
            "服务预约管理",
            "家属沟通平台",
            "活动参与社区",
          ],
        },
        {
          name: "智能呼叫中心",
          brief: "全天候服务响应系统",
          icon: "el-icon-service",
          color: "#45B7D1",
          isFlipped: false,
          features: [
            // "多渠道接入(电话/微信/App)",
            "电话",
            "智能工单分配",
            "服务人员调度",
            "服务过程跟踪",
            "满意度评价",
          ],
        },
        {
          name: "数据大屏",
          brief: "可视化运营管理平台",
          icon: "el-icon-monitor",
          color: "#A178DF",
          isFlipped: false,
          features: [
            "实时数据可视化",
            "多维度数据分析",
            "异常情况预警",
            "自定义报表生成",
            "多终端展示",
          ],
        },
        {
          name: "后台管理系统",
          brief: "全方位运营管理平台",
          icon: "el-icon-setting",
          color: "#FFA07A",
          isFlipped: false,
          features: [
            "用户权限管理",
            "服务流程配置",
            "数据统计分析",
            "系统参数设置",
            "多机构管理",
          ],
        },
      ],
      workflow: [
        {
          title: "需求接入",
          description: "通过App、电话、微信等多渠道接收服务请求",
          product: "智能呼叫中心",
          icon: "el-icon-service",
          color: "#45B7D1",
        },
        {
          title: "任务分配",
          description: "智能算法根据位置、技能匹配最优服务人员",
          product: "后台管理系统",
          icon: "el-icon-setting",
          color: "#FFA07A",
        },
        {
          title: "服务执行",
          description: "服务人员通过App接收任务并执行服务",
          product: "养老App",
          icon: "el-icon-mobile-phone",
          color: "#4ECDC4",
        },
        {
          title: "质量监控",
          description: "通话中心实时监控服务质量，大屏展示关键指标",
          product: "数据大屏",
          icon: "el-icon-monitor",
          color: "#A178DF",
        },
        {
          title: "反馈闭环",
          description: "系统自动收集服务评价，持续优化服务流程",
          product: "智能通话中心",
          icon: "el-icon-phone-outline",
          color: "#FF6B6B",
        },
      ],
      techAdvantages: [
        {
          title: "高性能处理",
          description: "采用先进技术架构,确保系统稳定高效运行",
          icon: "el-icon-cpu",
        },
        {
          title: "安全保障",
          description: "多重加密保护,确保您的数据安全无忧",
          icon: "el-icon-connection",
        },
        {
          title: "专利优势",
          description:
            "已获得两项国家发明专利,五项软件著作权,国家级科技型中小企业",
          icon: "el-icon-lock",
        },
        {
          title: "智能分析",
          description: "内置智能AI分析工具,提供数据洞察支持",
          icon: "el-icon-link",
        },
        {
          title: "专业支持",
          description: "7X24小时技术支持团队随时待命",
          icon: "el-icon-mobile",
        },
        {
          title: "灵活扩展",
          description: "按需扩展资源,随业务增长而增长",
          icon: "el-icon-view",
        },
      ],
      cases: [
        {
          title: "XX市养老服务中心",
          description: "通过智能呼叫中心与App联动，提升服务响应速度60%",
          image: "https://via.placeholder.com/400x300?text=养老机构案例1",
          stats: [
            { value: "60%", label: "响应速度提升" },
            { value: "45%", label: "人力成本降低" },
            { value: "92%", label: "满意度提升" },
          ],
        },
        {
          title: "XX社区养老项目",
          description: "部署全套智慧养老系统，覆盖社区5000+长者",
          image: "https://via.placeholder.com/400x300?text=养老机构案例2",
          stats: [
            { value: "5000+", label: "服务长者" },
            { value: "30+", label: "服务项目" },
            { value: "24/7", label: "全天候服务" },
          ],
        },
        {
          title: "XX连锁养老机构",
          description: "多机构统一管理平台，实现标准化服务流程",
          image: "https://via.placeholder.com/400x300?text=养老机构案例3",
          stats: [
            { value: "15", label: "连锁机构" },
            { value: "80%", label: "效率提升" },
            { value: "5", label: "管理模块" },
          ],
        },
      ],
    };
  },
  mounted() {
    // 初始化动画库
    AOS.init({
      duration: 800,
      easing: "ease-out-back",
      once: true,
      offset: 120,
    });

    // 设置Element主题色
    document.documentElement.style.setProperty("--el-color-primary", "#f97d01");

    // 初始化案例轮播
    this.initCaseCarousel();
  },
  methods: {
    initCaseCarousel() {
      // 这里可以添加案例轮播的逻辑
      // 实际项目中可以使用Swiper等库实现
    },
  },
};
</script>

<style lang="scss">
/* 全局主题色 */
$primary-color: #f97d01;
$primary-light: lighten($primary-color, 35%);

.product-solutions-page {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #333;
  line-height: 1.6;

  /* 产品Banner */
  .product-banner {
    height: 80vh;
    min-height: 600px;
    background: url("https://via.placeholder.com/1920x1080?text=智慧养老产品矩阵")
      center/cover no-repeat;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    .banner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.6),
        rgba($primary-color, 0.4)
      );
    }

    .banner-content {
      position: relative;
      z-index: 2;
      color: #fff;

      h1 {
        font-size: 48px;
        font-weight: 600;
        margin-bottom: 20px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }

      .banner-subtitle {
        font-size: 22px;
        margin-bottom: 50px;
        opacity: 0.9;
      }
    }

    .product-scroll-hint {
      position: fixed;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;
      opacity: 0.8;
      animation: bounce 2s infinite;

      span {
        margin-bottom: 5px;
        font-size: 14px;
      }

      i {
        font-size: 20px;
      }
    }
  }

  /* 通用区块标题样式 */
  .section-header {
    text-align: center;
    margin: 100px 0 60px;

    h2 {
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 15px;
      color: #333;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 4px;
        background: $primary-color;
        border-radius: 2px;
      }
    }

    .section-subtitle {
      font-size: 18px;
      color: #666;
      margin-top: 25px;
    }
  }

  /* 产品展示 - 翻转卡片 */
  .product-showcase {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 30px;
  }

  .product-card {
    perspective: 1000px;
    height: 300px;

    .card-inner {
      position: relative;
      width: 100%;
      height: 100%;
      transition: transform 0.8s;
      transform-style: preserve-3d;
      cursor: pointer;

      &.is-flipped {
        transform: rotateY(180deg);
      }
    }

    .card-front,
    .card-back {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      border-radius: 12px;
      padding: 30px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .card-front {
      background: #fff;
      justify-content: center;

      .product-icon {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 25px;

        i {
          font-size: 36px;
          color: #fff;
        }
      }

      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #333;
      }

      .product-brief {
        font-size: 14px;
        color: #666;
        margin-bottom: 20px;
      }

      .flip-hint {
        font-size: 12px;
        color: #999;
        display: flex;
        align-items: center;

        i {
          margin-right: 5px;
          font-size: 14px;
        }
      }
    }

    .card-back {
      background: linear-gradient(135deg, #f5f7fa, #fff);
      transform: rotateY(180deg);
      padding: 25px;

      h4 {
        font-size: 18px;
        margin-bottom: 20px;
        color: $primary-color;
      }

      .feature-list {
        list-style: none;
        padding: 0;
        margin-bottom: 20px;
        text-align: left;
        flex-grow: 1;

        li {
          font-size: 13px;
          margin-bottom: 10px;
          color: #555;

          i {
            color: $primary-color;
            margin-right: 5px;
          }
        }
      }
    }
  }

  /* 工作流程 */
  .workflow-steps {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 40px;
      left: 40px;
      height: calc(100% - 80px);
      width: 2px;
      background: linear-gradient(to bottom, #f0f0f0, #f0f0f0);
      z-index: 0;
    }
  }

  .workflow-step {
    position: relative;
    padding: 30px 30px 30px 80px;
    margin-bottom: 30px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    display: flex;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

      .step-number {
        transform: scale(1.1);
      }
    }

    .step-number {
      position: absolute;
      left: 20px;
      top: 30px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: var(--step-color);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 18px;
      transition: all 0.3s;
      z-index: 1;
    }

    .step-content {
      flex: 1;

      h3 {
        font-size: 18px;
        margin-bottom: 10px;
        color: #333;
      }

      p {
        font-size: 14px;
        color: #666;
        line-height: 1.6;
      }
    }

    .step-product {
      margin-left: 20px;
      display: flex;
      align-items: center;

      .product-badge {
        padding: 8px 15px;
        border-radius: 20px;
        color: #fff;
        font-size: 14px;
        display: flex;
        align-items: center;

        i {
          margin-right: 5px;
          font-size: 16px;
        }
      }
    }
  }

  /* 技术优势 */
  .advantage-cards {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
  }

  .advantage-card {
    background: #fff;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
    text-align: center;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

      .advantage-icon {
        background: $primary-color;
        color: #fff;
      }
    }

    .advantage-icon {
      width: 70px;
      height: 70px;
      margin: 0 auto 20px;
      background: $primary-light;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;

      i {
        font-size: 30px;
        color: $primary-color;
      }
    }

    h3 {
      font-size: 18px;
      margin-bottom: 15px;
      color: #333;
    }

    p {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
    }
  }

  /* 案例展示 */
  .case-carousel {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    overflow: hidden;
  }

  .case-track {
    display: flex;
    gap: 30px;
    padding: 20px 0;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: $primary-color;
      border-radius: 3px;
    }
  }

  .case-card {
    flex: 0 0 calc(33.333% - 20px);
    min-width: 300px;
    scroll-snap-align: start;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: all 0.4s;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
    }

    .case-image {
      height: 200px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .case-content {
      padding: 25px;

      h3 {
        font-size: 18px;
        margin-bottom: 15px;
        color: #333;
      }

      .case-desc {
        font-size: 14px;
        color: #666;
        margin-bottom: 20px;
        line-height: 1.6;
      }
    }

    .case-stats {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;

      .stat-item {
        text-align: center;

        .stat-value {
          font-size: 20px;
          font-weight: 600;
          color: $primary-color;
          margin-bottom: 5px;
        }

        .stat-label {
          font-size: 12px;
          color: #999;
        }
      }
    }
  }

  /* 底部CTA */
  .product-cta {
    padding: 100px 0;
    margin-top: 80px;
    background: linear-gradient(
      135deg,
      $primary-color,
      darken($primary-color, 10%)
    );
    color: #fff;
    text-align: center;

    .cta-content {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 20px;

      h2 {
        font-size: 36px;
        margin-bottom: 20px;
      }

      p {
        font-size: 18px;
        margin-bottom: 30px;
        opacity: 0.9;
      }
    }

    .cta-button {
      padding: 14px 40px;
      font-size: 18px;
      background: #fff;
      color: $primary-color;
      border: none;
      font-weight: 500;
      transition: all 0.3s;

      &:hover {
        background: rgba(255, 255, 255, 0.9);
        transform: translateY(-3px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
      }
    }
  }

  /* 动画效果 */
  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0) translateX(-50%);
    }
    40% {
      transform: translateY(-10px) translateX(-50%);
    }
    60% {
      transform: translateY(-5px) translateX(-50%);
    }
  }

  /* 响应式调整 */
  @media (max-width: 992px) {
    .product-banner {
      height: 600px;

      h1 {
        font-size: 36px !important;
      }

      .banner-subtitle {
        font-size: 18px !important;
      }
    }

    .workflow-step {
      flex-direction: column;
      padding: 25px 25px 25px 70px;

      .step-product {
        margin-left: 0;
        margin-top: 15px;
        justify-content: flex-end;
        width: 100%;
      }
    }

    .case-card {
      flex: 0 0 calc(50% - 15px);
    }
  }

  @media (max-width: 768px) {
    .product-banner {
      height: 500px;

      h1 {
        font-size: 28px !important;
      }

      .banner-subtitle {
        font-size: 16px !important;
      }
    }

    .section-header h2 {
      font-size: 28px !important;
    }

    .product-showcase {
      grid-template-columns: 1fr;
      max-width: 400px;
      margin: 0 auto;
    }

    .workflow-steps {
      &::before {
        display: none;
      }
    }

    .workflow-step {
      padding: 20px;

      .step-number {
        position: static;
        margin-bottom: 15px;
      }
    }

    .case-card {
      flex: 0 0 100%;
    }

    .product-cta h2 {
      font-size: 28px !important;
    }
  }
}
</style>
